import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { GENERIC_ERROR_TOAST } from '@app/shared/common/constants';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const SUPPRESS_ERROR_MESSAGE = new HttpContextToken(() => false);

export const serverErrorMessageInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  const suppress = req.context.get(SUPPRESS_ERROR_MESSAGE) === true;

  const isServerError = (error: HttpErrorResponse) =>
    error instanceof HttpErrorResponse && (error.status >= 500 || error.status === 0);

  return next(req).pipe(
    catchError((error) => {
      if (!suppress && isServerError(error)) messageService.add(GENERIC_ERROR_TOAST);

      return throwError(() => error);
    }),
  );
};
